const cards = [
  {
    title: '某顶流男星深夜密会神秘女子',
    desc: '据知情人士爆料，某当红顶流男星近日被拍到深夜与神秘女子出入高档酒店，全程举止亲密，引发粉丝热议。',
    tag: '明星八卦',
    image: 'https://readdy.ai/api/search-image?query=Dark%20paparazzi%20style%20photography%20of%20a%20celebrity%20silhouette%20walking%20at%20night%20in%20a%20luxury%20hotel%20district%2C%20dramatic%20moody%20lighting%20with%20warm%20street%20lamps%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20soft%20focus%20blur%20background&width=800&height=500&seq=card-01-celebrity&orientation=landscape',
  },
  {
    title: '知名网红被爆偷税漏税金额惊人',
    desc: '税务部门最新通报显示，某头部直播带货网红涉嫌偷逃税款，涉案金额高达数千万，账号已被平台封禁。',
    tag: '网络热点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20investigation%20concept%20with%20stacked%20documents%20and%20calculator%20on%20dark%20wooden%20desk%2C%20warm%20amber%20ambient%20light%2C%20dramatic%20shadows%2C%20professional%20documentary%20photography%20style&width=800&height=500&seq=card-02-tax&orientation=landscape',
  },
  {
    title: '热门综艺节目录制现场意外曝光',
    desc: '某王牌综艺节目最新一期录制现场突发状况，多位嘉宾情绪失控，节目组紧急叫停录制动用应急预案。',
    tag: '影视综艺',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20TV%20studio%20set%20with%20dramatic%20stage%20lighting%20and%20empty%20audience%20seats%2C%20warm%20spotlight%20beams%2C%20professional%20broadcast%20equipment%20in%20background%2C%20atmospheric%20behind%20the%20scenes%20photography&width=800&height=500&seq=card-03-variety&orientation=landscape',
  },
  {
    title: '某女星疑似整容后首次公开亮相',
    desc: '消失数月后首次出席活动的某知名女星，面部轮廓明显变化，网友纷纷对比前后照片热议不断。',
    tag: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20photography%20with%20soft%20glamorous%20lighting%2C%20fashionable%20silhouette%20in%20luxury%20gown%2C%20photographers%20and%20flashing%20cameras%20in%20background%2C%20celebrity%20event%20vibe%2C%20warm%20golden%20tone&width=800&height=500&seq=card-04-redcarpet&orientation=landscape',
  },
  {
    title: '某品牌代言人翻车引全网群嘲',
    desc: '某国际品牌最新广告代言人因不当言论引发众怒，品牌方连夜发声明解约，相关话题阅读量破5亿。',
    tag: '品牌风波',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20controversy%20concept%20photography%2C%20smartphone%20screen%20showing%20trending%20hashtags%20against%20dark%20background%2C%20warm%20red%20and%20amber%20neon%20glow%2C%20intense%20dramatic%20atmosphere%2C%20modern%20digital%20culture%20aesthetic&width=800&height=500&seq=card-05-backlash&orientation=landscape',
  },
  {
    title: '娱乐圈某对CP被爆已秘密领证',
    desc: '知情人士透露，因戏生情的某对当红CP已在海外秘密登记结婚，双方工作室至今未正面回应此事。',
    tag: 'CP爆料',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20silhouette%20of%20a%20couple%20holding%20hands%20against%20warm%20golden%20sunset%20city%20skyline%2C%20soft%20dreamy%20bokeh%20effect%2C%20cinematic%20romantic%20atmosphere%2C%20elegant%20and%20mysterious%20mood%2C%20luxury%20lifestyle%20photography&width=800&height=500&seq=card-06-couple&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            热门爆料
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全网最新黑料吃瓜内容精选</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium text-background-50 bg-primary-500/90 rounded-full whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    2小时前
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {Math.floor(Math.random() * 90 + 10)}.{Math.floor(Math.random() * 9)}万
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}